// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2mkJT","boxTitle":"Qualiphy_boxTitle__B_hjD","box":"Qualiphy_box__3LUtN","toggleWrap":"Qualiphy_toggleWrap__daVa5"};